module.exports = __webpack_public_path__ + "img/soft_9.a743815f.png";